import { IconPropsType } from '..';

export const ArrowUpLongIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.01458 13.333L9.01458 4.93301L11.1479 7.05434L11.9839 6.21967L8.42258 2.66634L4.86658 6.22234L5.70258 7.05701L7.83058 4.93301L7.83058 13.333L9.01458 13.333Z"
      fill="currentColor"
    />
  </svg>
);
